document.addEventListener("DOMContentLoaded", function () {
  function applyCustomSparkStyles() {
    const globalObserver = new MutationObserver(() => {
      // Cart/Drawer styles
      const drawers = document.querySelectorAll("spark-drawer");

      if (drawers.length > 0) {

        drawers.forEach((drawer, drawerIndex) => {
          if (drawer.shadowRoot) {

            // Try multiple selectors and add delay for content to load
            const trySelectors = () => {
              // Try different selector variations
              const selectors = [
                "div.border-input.w-28",
                "div.w-28.border-input",
                "div.w-28",
                "div.border-input",
                "[class*='w-28']",
                "div[class*='border-input'][class*='w-28']",
              ];

              let quantitySelectors = [];

              for (const selector of selectors) {
                quantitySelectors =
                  drawer.shadowRoot.querySelectorAll(selector);
                if (quantitySelectors.length > 0) break;
              }

              // Debug: show all divs in shadowRoot
              const allDivs = drawer.shadowRoot.querySelectorAll("div");

              if (quantitySelectors.length > 0) {
                quantitySelectors.forEach((quantitySelector, qsIndex) => {
                  quantitySelector.style.setProperty(
                    "width",
                    "14rem",
                    "important"
                  );
                  quantitySelector.style.setProperty(
                    "min-width",
                    "14rem",
                    "important"
                  );
                });
              } else {
                setTimeout(trySelectors, 500);
              }
            };

            // Try immediately and also with delay
            trySelectors();
          }
        });
      }
    });

    globalObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Función para aplicar estilos solo en pantallas de hasta 750px
  function applyStylesIfMobile() {
    if (window.innerWidth <= 750) {
      // Crear un observer para monitorear cambios en el DOM general
      const observer = new MutationObserver(() => {
        const components = document.querySelectorAll("spark-product-card");
        components.forEach((component, index) => {
          if (component.shadowRoot) {
            // Encuentra todos los elementos <select> dentro del shadow root y aplica los estilos
            const selectElements =
              component.shadowRoot.querySelectorAll("select");
            selectElements.forEach((select, selectIndex) => {
              select.style.minWidth = "0";
              select.style.setProperty("min-width", "0", "important");
              select.style.width = "75%";
              select.style.setProperty("width", "75%", "important");
              console.log(
                `Estilos aplicados al <select> en posición ${selectIndex} dentro del componente ${index}: min-width eliminado, width establecido al 75%`
              );
            });

            // Encuentra el botón con la clase .btn-small dentro del shadow root y aplica el estilo
            /* const button = component.shadowRoot.querySelector('.btn-small');
            if (button) {
              button.style.width = "83%";
              button.style.setProperty("width", "83%", "important");
            } */
          }
        });
      });

      // Configuración del observer para observar hijos dentro del DOM general
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  const cartButton = document.querySelector(".header__icon--cart");

  applyCustomSparkStyles();
  cartButton.addEventListener("click", applyCustomSparkStyles);

  // Llama a la función inicialmente y también al redimensionar la ventana
  applyStylesIfMobile();
  window.addEventListener("resize", applyStylesIfMobile);
});
